angular.module('clientDashboardApp').controller("ReviewTagsModalCtrl",function($scope,parentScope,config,configService, confirmService) {

  $scope.config = {}
  angular.copy(config,$scope.config)
  $scope.restrictionConfig = {
    restrictionsToUpdate : {}
  }

  const removeReviewTag = (tagToDelete) => {
    $scope.state = states.editing
    $scope.setReviewTags(_.difference($scope.reviewTags,[tagToDelete]))
  }

  $scope.deleteTag = tag => confirmService.confirm(
    'Warning',
    'This will remove this tag from all reviews!',
    confirmService.WARNING
  ).then(confirmedDelete => {
    if (confirmedDelete) {
      removeReviewTag(tag)
    }

    $scope.calculateCanSubmit()
  })

  let states = parentScope.states

  const sortTags = (tags) => {
    return tags.sort(function(a, b){
      if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    })
  }

  $scope.state = states.init
  $scope.reviewTags = []
  $scope.selectedTab = "tabs"
  $scope.brandModalConfig = {
    state : {
      updating: false,
      success: false
    },
    save : false,
    reviewTagTerm : ""
  }
  $scope.reviewTags = sortTags($scope.config.reviewTags)
  $scope.brandModalConfig.save = false;

  $scope.setReviewTags = (tags) => {
    $scope.reviewTags = sortTags(tags);
  }


  $scope.setSelectedTab = (name) => {
    $scope.selectedTab = name;
    $scope.state = states.init
  }

  $scope.addReviewTag = (term) => {
    $scope.state = states.editing
    if(term !== ""){
      const newCat = {tempId: new Date().getMilliseconds().toString(), name: term};
      $scope.reviewTags.push(newCat)
      $scope.brandModalConfig.reviewTagTerm = ""
      $scope.setReviewTags($scope.reviewTags)
    }
  }

  $scope.maxReviewTagNameLength = 30

  $scope.calculateCanSubmit = () => {
    const oneHasTooMany = $scope.reviewTags.find(x => {
      return x.name.length > $scope.maxReviewTagNameLength
    }) !== undefined

    const tagNameCounts = $scope.reviewTags.map(x => x.name).reduce((acc, tagName) => {
      acc[tagName] ? acc[tagName]++ : acc[tagName] = 1;

      return acc
    }, {})

    const hasDuplicateTags = Object.values(tagNameCounts).find(count => count > 1) !== undefined

    $scope.canSubmit = oneHasTooMany || hasDuplicateTags
  }

  $scope.calculateCanSubmit()

  $scope.tagTermAlreadyExists = tagName => $scope.reviewTags.filter(x => x.name === tagName).length > 0

  $scope.duplicateTerm = tagName => {
    const duplicate = $scope.reviewTags.filter(x => x.name === tagName).length > 1

    return duplicate
  }

  $scope.tooManyChars = () => {
    const tooMany = $scope.reviewTags.find(x => x.length > 30)
    return tooMany
  }


  $scope.save = function(){
    $scope.state = states.updating;

    configService.saveReviewTags(parentScope.userInfo.accountId,$scope.reviewTags).then((resp) => {
      configService.getBrandConfig(false,true).then(function (configResp) {
        $scope.config = configResp
        $scope.setReviewTags($scope.config.reviewTags)
        $scope.state = states.success;
        /*onSave(configResp)*/
      })

    },(error) => {
      $scope.state = states.error;
    })
  }

});
